import { useQuery } from '@tanstack/react-query';
import { api } from 'lib/httpClient';

export const useInvestorAppropriatenessQuestionList = () => {
  return useQuery({
    queryKey: ['investorQuestions'],
    queryFn: async () => {
      const { data } = await api.get('investor/question-list', {
        params: { isAdmin: true },
      });
      return data.data;
    },
  });
};
